export default {
    "validations.required": "Dit veld is verplicht",
    "validations.maxLength": "Maximaal {max} karakters",
}
